var _circle, _g, _rect, _rect2, _rect3, _rect4, _path, _path2, _rect5, _rect6, _rect7, _rect8, _path3, _path4, _rect9, _rect10, _rect11, _rect12, _path5, _path6, _rect13, _path7, _rect14, _rect15, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoDashboards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 400,
    r: 400,
    fill: "#E6F7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1211_24269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 119H246V189H759V680H41V119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246 189.5H758.5V679.5H41.5V119.5H245.5V189V189.5H246Z",
    stroke: "#69C0FF"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 242,
    width: 287,
    height: 181.909,
    rx: 19,
    fill: "#BAE7FF",
    stroke: "#1890FF",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 105.086,
    y: 250.984,
    width: 105.091,
    height: 12.6109,
    rx: 6.30545,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 105.086,
    y: 268.324,
    width: 37.3073,
    height: 8.40727,
    rx: 4.20364,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 152.902,
    y: 268.324,
    width: 37.3073,
    height: 8.40727,
    rx: 4.20364,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.086 290.918V412.824H367.813",
    stroke: "white",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.34 361.329L112.297 360.643C152.458 346.572 195.798 344.24 237.237 353.919V353.919V353.919C278.337 359.477 320.111 351.041 355.833 329.97L364.134 325.073",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 450.909,
    width: 287,
    height: 181.909,
    rx: 19,
    fill: "#BAE7FF",
    stroke: "#1890FF",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 105.086,
    y: 459.893,
    width: 105.091,
    height: 12.6109,
    rx: 6.30545,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 105.086,
    y: 477.233,
    width: 37.3073,
    height: 8.40727,
    rx: 4.20364,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 152.902,
    y: 477.233,
    width: 37.3073,
    height: 8.40727,
    rx: 4.20364,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.086 499.827V621.733H367.813",
    stroke: "white",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.34 570.238L112.297 569.552C152.458 555.481 195.798 553.149 237.237 562.828V562.828V562.828C278.337 568.386 320.111 559.95 355.833 538.879L364.134 533.982",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 242,
    width: 287,
    height: 181.909,
    rx: 19,
    fill: "#BAE7FF",
    stroke: "#1890FF",
    strokeWidth: 2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 429.086,
    y: 250.984,
    width: 105.091,
    height: 12.6109,
    rx: 6.30545,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 429.086,
    y: 268.324,
    width: 37.3073,
    height: 8.40727,
    rx: 4.20364,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 476.902,
    y: 268.324,
    width: 37.3073,
    height: 8.40727,
    rx: 4.20364,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M429.086 290.918V412.824H691.813",
    stroke: "white",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M434.34 361.329L436.297 360.643C476.458 346.572 519.798 344.24 561.237 353.919V353.919V353.919C602.337 359.477 644.111 351.041 679.833 329.97L688.134 325.073",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 450.909,
    width: 287,
    height: 181.404,
    rx: 19,
    stroke: "#40A9FF",
    strokeWidth: 2,
    strokeDasharray: "8 8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568.447 517.296H554.553V534.664L537.186 534.664V548.558H554.553V565.926H568.447V548.558H585.815V534.664L568.447 534.664V517.296Z",
    fill: "#BAE7FF"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 150,
    width: 46,
    height: 13,
    rx: 6.5,
    fill: "#69C0FF"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 150,
    width: 94,
    height: 13,
    rx: 6.5,
    fill: "#69C0FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1211_24269",
    x: 25,
    y: 107,
    width: 750,
    height: 593,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1211_24269"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1211_24269",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDashboards);
export default __webpack_public_path__ + "static/media/no-dashboards.8aebff71.svg";
export { ForwardRef as ReactComponent };